import * as React from "react";
import { useContext, useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { exportToCsv, exportToExcel } from "@/utils";
import { useTextDomainContext } from "@/app/providers";
import { TfiImport } from "react-icons/tfi";
import { arrayOf, object, string } from "prop-types";

export const ExportDropdown = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const open = Boolean(anchorEl);

  // Use props directly with fallbacks instead of state
  const data = props.data || [];
  const fileName = props.fileName || "export";

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportToExcel = () => {
    exportToExcel(data, `${fileName}.xlsx`);
    handleClose();
  };

  const handleExportToCsv = () => {
    exportToCsv(data, `${fileName}.csv`);
    handleClose();
  };

  // const handleExportToPdf = () => {
  //   ExportToPdf(data, `${fileName}.pdf`);
  //   handleClose();
  // };

  return (
    <>
      <Button
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={<TfiImport size={14} />}
        disabled={!data?.length}
        sx={{
          ml: 1,
          color: "grey.600",
          fontWeight: 400,
        }}
      >
        {gettext("export")}
      </Button>
      <Menu
        id="fade-menu"
        slotProps={{
          paper: {
            "aria-labelledby": "fade-button",
          },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slots={{
          transition: Fade,
        }}
      >
        <MenuItem
          onClick={handleExportToExcel}
          sx={{
            fontSize: "0.875rem",
            color: "grey.600",
            fontWeight: 300,
          }}
        >
          {gettext("export to Excel")}
        </MenuItem>
        <MenuItem
          onClick={handleExportToCsv}
          sx={{
            fontSize: "0.875rem",
            color: "grey.600",
            fontWeight: 300,
          }}
        >
          {gettext("export to CSV")}
        </MenuItem>
        {/*<MenuItem*/}
        {/*  onClick={handleExportToPdf}*/}
        {/*  sx={{*/}
        {/*    fontSize: "0.875rem",*/}
        {/*    color: "grey.600",*/}
        {/*    fontWeight: 300*/}
        {/*  }}*/}
        {/*>*/}
        {/*  {gettext("export to PDF")}*/}
        {/*</MenuItem>*/}
      </Menu>
    </>
  );
};

ExportDropdown.propTypes = {
  data: arrayOf(object),
  fileName: string,
};
